var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreIconWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H2.48765C2.23003 0 1.9724 0.140625 1.83187 0.351562L0.332944 2.78906C-0.463362 4.05469 0.239261 5.78906 1.69135 5.97656C1.80845 6 1.90213 6 2.01924 6C2.72186 6 3.3308 5.69531 3.75237 5.22656C4.17395 5.69531 4.78289 6 5.48551 6C6.06605 6 6.59525 5.7774 7 5.42003V0Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H3.5025V6.67969C3.26829 6.72656 2.25345 6.75 2.01924 6.75C1.87871 6.75 1.73819 6.75 1.59766 6.72656C1.45714 6.70312 1.34004 6.67969 1.22293 6.65625V11.25C1.22293 11.6719 1.55082 12 1.9724 12H7V9Z",
    fill: "#5062F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H11.5123C11.77 0 12.0276 0.140625 12.1681 0.351562L13.6671 2.78906C14.4634 4.05469 13.7607 5.78906 12.3087 5.97656C12.1915 6 12.0979 6 11.9808 6C11.2781 6 10.6692 5.69531 10.2476 5.22656C9.82605 5.69531 9.21711 6 8.51449 6C7.93395 6 7.40475 5.7774 7 5.42003V0Z",
    fill: "#5062F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H10.4975V6.67969C10.7317 6.72656 11.7466 6.75 11.9808 6.75C12.1213 6.75 12.2618 6.75 12.4023 6.72656C12.5429 6.70312 12.66 6.67969 12.7771 6.65625V11.25C12.7771 11.6719 12.4492 12 12.0276 12H7V9Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIconWs);
export default __webpack_public_path__ + "static/media/storeIconWS.6bf00979abae38c943dd196876ecfb5e.svg";
export { ForwardRef as ReactComponent };